import {Vue} from "ui.vue";
import "citrus.plugins.form.request";
import "citrus.vue.dialog";

export let FormMixin = {
	data: function () {
		return {
			needScrollToError: false,
			firstInValidFields: false,
			metricGoal: false,
			loading: false,
			error: false,
			fileError: false,
			success: false,
			message: '',
			message_descr: '',
		}
	},
	computed: {
		allFieldsFilled() {
			return this.fieldsFilled();
		},
		locMixin() {
			return Vue.getFilteredPhrases("CITRUS_FORM_MIXIN_");
		}
	},
	methods: {
		isFileError(data) {
			this.fileError = data.error;
		},
		async isValidate(component, isValid = true)
		{
			this.firstInValidFields = false;
			let val = null, self = this,
				ref = 'field', refGroup = 'group';

			if (component) {
				self = component;
			}

			if (self.$refs.hasOwnProperty(ref)) {
				let isIterable = self.$refs[ref] != null && typeof self.$refs[ref][Symbol.iterator] === 'function';
				if (isIterable) {
					for (let field of self.$refs[ref]) {
						val = await field.checkValid();
						if (!val) {
							isValid = false;

							if(false === this.firstInValidFields)
							{
								console.log(field);

								this.firstInValidFields = field;
							}
						}
					}
				}
				else {
					isValid = await self.$refs[ref].checkValid();
					if(!isValid && false === this.firstInValidFields)
					{
						this.firstInValidFields = self.$refs[ref];
					}
				}
			} else if (self.$refs.hasOwnProperty(refGroup)) {
				let isIterable = self.$refs[refGroup] != null && typeof self.$refs[refGroup][Symbol.iterator] === 'function';
				if (isIterable) {
					for (let group of self.$refs[refGroup]) {
						val = await this.isValidate(group);
						if (!val) {
							isValid = false;

							if(false === this.firstInValidFields)
							{
								this.firstInValidFields = field;
							}
						}
					}
				}
				else {
					isValid = await this.isValidate(self.$refs[refGroup], isValid);
					if(!isValid && false === this.firstInValidFields)
					{
						this.firstInValidFields = self.$refs[refGroup];
					}
				}
			}
			return isValid;
		},
		resetValid(component) {
			let self = this, ref = 'field', refGroup = 'group';

			if (component) {
				self = component;
			}

			if (self.$refs.hasOwnProperty(ref)) {
				for (let field of self.$refs[ref]) {
					field.resetValid();
				}
			} else if (self.$refs.hasOwnProperty(refGroup)) {
				for (let group of self.$refs[refGroup]) {
					this.resetValid(group);
				}
			}

			this.firstInValidFields = false;
		},
		/**
		 * On form submit
		 *
		 * @param {Event} $event
		 */
		async onSubmit($event) {
			if (this.loading) {
				return;
			}

			let isValid = await this.isValidate();

			if (!isValid || this.fileError) {
				if(this.firstInValidFields && this.needScrollToError)
				{
					this.firstInValidFields.$el.scrollIntoView(true);
					window.scrollBy(0, -250);
				}

				return;
			}

			this.resetResult();

			let formData = new FormData();

			formData.append('FORM_ID', this.formId);
			formData.append('SITE_ID', this.siteId || BX.message("SITE_ID"));
			formData.append('sessid', BX.bitrix_sessid());

			this.prepareData(formData);

			if (this.$data.hasOwnProperty('existFiles') && Array.isArray(this.$data.existFiles)) {
				let existFileIds = [], existFile;
				for (let i in this.$data.existFiles) {
					if (typeof this.$data.existFiles[i] === 'object') {
						existFile = this.$data.existFiles[i];
						if (null !== existFile && existFile.hasOwnProperty('id') && existFile.id > 0) {
							existFileIds.push(Number(existFile.id));
						}
					}
				}

				formData.append("EXIST_FILES", existFileIds);
				this.existFiles = [];
			}

			this.$request
				.setModeComponent()
				.setOption({
					componentName: this.componentName,
					action: this.action,
					signedParameters: this.signedParameters
				})
				.setData(formData)
				.send()
				.then((response) => {

					// отправим метрику
					if(this.metricGoal)
					{
						this.$metrika.reachGoal(this.metricGoal);
						this.$gtag.event(this.metricGoal);
					}

					this.onResponse(response);
				}, (error) => {
					this.resetFields();
					this.onError(error);
				})
			;
		},
		prepareData(formData, fields = this.formFields) {
			for (let field of fields) {
				if (field.hasOwnProperty('MULTIPLE') && field.MULTIPLE) {
					for (var i = 0; i < field.VALUE.length; i++) {
						formData.append(field.CODE + '[' + i + ']', field.VALUE[i]);
					}
				} else if (field.GROUP_FIELD == true) {
					if (field.ITEMS) {
						this.prepareData(formData, field.ITEMS);
					}
				} else {
					formData.append(field.CODE, field.VALUE);
				}
			}
		},
		onResponse(response) {
			if (typeof response == 'object' && null !== response) {
				let message = response.hasOwnProperty("message") && response.message
					? response.message
					: this.getDefaultErrorMessage();

				this.onError(message);
			}
			else {
				this.onSuccess({message: response});
			}
		},
		getDefaultErrorMessage() {
			return this.locMixin.CITRUS_FORM_MIXIN_ERROR_MESSAGE;
		},
		resetResult() {
			this.loading = true;
			this.success = false;
			this.error = false;
			this.message = "";
		},
		getSuccessDescription() {
			return this.locMixin.CITRUS_FORM_MIXIN_OK_MESSAGE_DESCR;
		},
		getErrorDescription() {
			return this.locMixin.CITRUS_FORM_MIXIN_ERROR_MESSAGE_DESC;
		},
		onSuccess(response) {
			this.success = true;
			this.message = response.hasOwnProperty("message") ? response.message : this.locMixin.CITRUS_FORM_MIXIN_OK_MESSAGE;
			this.error = false;
			this.loading = false;

			this.message_descr = this.getSuccessDescription();

			if (!this.$dialog) {
				alert(this.message + " " + this.message_descr);
				this.restartForm();

				return;
			}

			this.$dialog
				.alert({
					title: this.message,
					body: this.message_descr,
					pretitle: '<div class="m-auto h-28 mb-6">' + this.icons.success + '</div>'
				}, {
					html: true,
					okText: this.locMixin.CITRUS_FORM_MIXIN_CLOSE
				})
				.then(() => {
					this.restartForm();
				});
		},
		onError(message) {
			this.success = false;
			this.error = true;
			this.message = message;
			this.loading = false;

			this.message_descr = this.getErrorDescription();

			if (!this.$dialog) {
				alert(this.message + " " + this.message_descr);
				this.restartForm();

				return;
			}

			this.$dialog
				.alert({
					title: this.message,
					body: this.message_descr,
				}, {
					html: true,
					okText: this.locMixin.CITRUS_FORM_MIXIN_CLOSE
				})
				.then(() => {
					this.restartForm();
				});
		},
		restartForm: function () {
			this.loading = false;
			this.success = false;
			this.error = false;
			this.message = "";
			this.message_descr = "";

			this.resetFields();
		},
		resetFields(fields = this.formFields) {
			for (let field of fields) {
				if (true === field.HIDDEN)
					continue;

				if (field.GROUP_FIELD == true) {
					if (field.ITEMS) {
						this.resetFields(field.ITEMS);
					}
				} else {
					field.VALUE = '';
				}
			}
		},
		fieldsFilled(fields = this.formFields, status = true) {
			let isFilled = status;

			for (let field of fields) {
				if (field.GROUP_FIELD == true) {
					if (field.ITEMS) {
						isFilled = this.fieldsFilled(field.ITEMS, isFilled);
					}
				} else if (!field.VALUE && field.REQUIRED == "Y") {
					return isFilled = false;
				}
			}
			return isFilled;
		}
	}
};

export default {FormMixin};
